import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background} d="m19.2 30.9-2.8-2.8c-.1-.1-.2-.1-.2-.2-.2-.1-.4-.1-.6 0-.1 0-.2.1-.2.2l-2.8 2.8c-.3.3-.3.8 0 1.1s.8.3 1.1 0l1.5-1.5v5.1c0 .4.3.8.8.8s.8-.3.8-.8v-5.1l1.5 1.5c.1.1.3.2.5.2s.4-.1.5-.2c.2-.3.2-.8-.1-1.1z" />
    <path fill={props.background} d="m26 40.8-2.5.7v-38l17.8 5.1v16c0 .4.3.8.8.8s.8-.3.8-.8V8c0-.3-.2-.6-.5-.7L23 1.8h-.4L3.3 7.3c-.3.1-.5.4-.5.7v29c0 .3.2.6.5.7l19.3 5.5h.4l3.4-1c.4-.1.6-.5.5-.9-.1-.4-.5-.6-.9-.5zM9.8 7l5.4-1.5v16l-.6.6-1.6-1.5c-.3-.3-.8-.3-1.1 0l-1.5 1.5-.6-.6V7zM4.2 8.6l4-1.1v14.4c0 .2.1.4.2.5l1.4 1.4c.3.3.8.3 1.1 0l1.5-1.5 1.5 1.5c.1.1.3.2.5.2s.4-.1.5-.2l1.4-1.4c.1-.1.2-.3.2-.5V5l5.4-1.5v38L4.2 36.4V8.6z" />
    <path fill={props.background} d="M35.2 25.2c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16.6c-4.2 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5c.1 4.1-3.3 7.5-7.5 7.5z" />
    <path fill={props.background} d="m38.8 30.9-5 5-2.2-2.2c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l2.8 2.8c.1.1.3.2.5.2s.4-.1.5-.2l5.5-5.5c.3-.3.3-.8 0-1.1s-.7-.4-1-.1z" />
  </svg>
)

export default SvgComponent
